import ProductStats from './ProductStats';
// import InventoryTurnoverRateGraph from './InventoryTurnoverRate.Graph';
import AgedInventory from './AgedInventory';
import LowInventoryItems from './LowInventoryItems';
// import AggregatedSalesVelocity from './AggregatedSalesVelocity.Graph';
// import AggregatedSellThroughRate from './AggregatedSellThroughRate.Graph';

// import {
//     aggregatedSalesVelocity,
//     aggregatedSellThroughRate,
//     productReviews
// } from '../../ChartData';
// import ProductReviewsGraph from './ProductReviews.Graph';
// import ProductInsightsList from './ProductInsightsList';

function ProductAndInventoryInsights() {
    return (
        <>
            <ProductStats />

            <div className="flex mt-3 mx-5">
                {/* <InventoryTurnoverRateGraph /> */}
            </div>

            <div className="flex mt-3 mx-5 gap-3">
                <AgedInventory />

                <LowInventoryItems />
            </div>

            <div className="flex mt-3 mx-5">
                {/* <AggregatedSalesVelocity 
                    aggregatedSalesVelocityData={aggregatedSalesVelocity}
                /> */}
            </div>

            <div className="flex mt-3 mx-5">
                {/* <AggregatedSellThroughRate 
                    aggregatedSellThroughRateData={aggregatedSellThroughRate}
                /> */}
            </div>

            <div className="flex mt-3 mx-5">
                {/* <ProductReviewsGraph 
                    productReviewsData={productReviews} 
                /> */}
            </div>

            {/* <ProductInsightsList /> */}
        </>
    );
}

export default ProductAndInventoryInsights;
